import {FINDER_OVERVIEW_SET_ITEMTYPENAME} from '~/frontend/src/constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import {clearElusiveData} from '~/frontend/src/actions/elusiveData';


/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} dataContext
 * @param {Schema} schema
 * @param {String} itemTypeName
 */
const setItemTypeName = ( panelKey : string, dataContext : string, schema : Schema, itemTypeName : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type   : FINDER_OVERVIEW_SET_ITEMTYPENAME,
        panelKey,
        dataContext,
        schema,
        itemTypeName
    } );

    // clear global data
    global.data[ dataContext ] = {
        items     : {},
        references: {},
        schema
    };

    dispatch( clearElusiveData( panelKey ) );
}
export type SetItemTypeName = typeof setItemTypeName;

export default setItemTypeName;
